import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { bancosAPI } from '../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../context/AuthContext';
import '../Clientes.css';

const Bancos = () => {
  const [bancos, setBancos] = useState([]);
  const [loading, setLoading] = useState(true);
  const { hasPermission } = useAuth();

  useEffect(() => {
    loadBancos();
  }, []);

  const loadBancos = async () => {
    try {
      setLoading(true);
      const response = await bancosAPI.getAll({ includeInactive: true });
      if (response.success) {
        setBancos(response.data);
      }
    } catch (error) {
      toast.error('Error al cargar bancos');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Está seguro de eliminar este banco?')) return;

    try {
      const response = await bancosAPI.delete(id);
      if (response.success) {
        toast.success('Banco eliminado exitosamente');
        loadBancos();
      }
    } catch (error) {
      toast.error(error.message || 'Error al eliminar banco');
    }
  };

  if (loading) {
    return <div className="loading">Cargando...</div>;
  }

  return (
    <div className="clientes pagina-listado pagina-listado--scroll">
      <div className="page-header">
        <h1>Bancos</h1>
        {hasPermission('gestionar_bancos') && (
          <Link to="/bancos/nuevo" className="btn-primary">Nuevo Banco</Link>
        )}
      </div>

      <div className="listado-panel clientes-listado listado-controles">
        <div className="listado-panel-cuerpo clientes-listado-cuerpo">
          <div className="listado-tabla-area clientes-listado-tabla-area">
            <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Código</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {bancos.length === 0 ? (
              <tr>
                <td colSpan="4" className="no-data">No hay bancos registrados</td>
              </tr>
            ) : (
              bancos.map(banco => (
                <tr key={banco.id}>
                  <td><strong>{banco.nombre}</strong></td>
                  <td>{banco.codigo || '-'}</td>
                  <td>
                    <span className={`badge ${banco.activo ? 'activo' : 'inactivo'}`}>
                      {banco.activo ? 'Activo' : 'Inactivo'}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      {hasPermission('gestionar_bancos') && (
                        <>
                          <Link to={`/bancos/editar/${banco.id}`} className="btn-edit">Editar</Link>
                          <button onClick={() => handleDelete(banco.id)} className="btn-delete">Eliminar</button>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bancos;

